// Production documents on POs, spread into `mutations` (shared/mutations.ts). Implementations: "Send update" in
// server/src/mutations/purchase-orders.ts, the documents link in server/src/mutations/po-docs.ts. Rules shared
// with the browser: shared/po-docs.ts.
import { z } from "zod";
import { custom, STAFF } from "./mutation-kit.ts";

export const poDocsMutations = {
  /** Moves a sent PO's lines to their items' newer spec revisions; the PO starts its next revision. */
  "po.send_spec_update": custom(z.object({ id: z.uuid() }), STAFF),
  /** A new documents link for a sent PO; its old link (and the QR on PDFs already sent) stops working. Returns the token. */
  "doc_link.regenerate": custom(z.object({ po_id: z.uuid() }), STAFF),
  /** Turns off a PO's documents link. */
  "doc_link.revoke": custom(z.object({ po_id: z.uuid() }), STAFF),
};
